import  { useRef, useState } from 'react'
import {  motion, useScroll, useTransform } from 'motion/react';
import { Box, Grid} from '@mui/material'
import CharcoalBG from '../assets/charcoal-bed.webp'
import { Item, nutritionalData } from '../content/menu-items';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { addItem, removeItem, selectedItems } from '../features/catering/cateringSlice';
import { CalculatorHUD } from '../components/price-calculator/CalculatorHUD';
import { ItemSelector } from '../components/price-calculator/ItemSelector';
import { ParallaxedBg } from '../components/animated-elements/ParallaxBg'

"use client"

export const CateringPage = () => {
    const [searchValue, setSearchValue] = useState<Item | null>(null)
    const mainContainer = useRef(null)
    const { scrollYProgress } = useScroll({
        target: mainContainer,
        offset: ['start start', 'end end']
    })
   
    const bgY = useTransform( scrollYProgress, [ 0, 1 ], [ '10vh', '-10vh' ])
    const itemList: Item[] = [...nutritionalData.grilledMeatsData, ...nutritionalData.smokedMeatsData, ...nutritionalData.otherEntreesData, ...nutritionalData.sidesData]
    const cart = useAppSelector(selectedItems)
    const dispatch = useAppDispatch()
 
    const handleSelectItem = (item: Item) => {
        if(item !== null){
            cart.includes(item)? dispatch(removeItem(item)): dispatch(addItem(item))
        }      
    }

    return(
        <motion.div layoutRoot ref={mainContainer} style={{  width: '100vw', position:'relative', display: 'flex', margin: 'auto', justifyContent: 'center', alignItems: 'center'}}>       
            <Grid container>
                <ParallaxedBg bgY={bgY} backgroundImage={CharcoalBG}/>
                <Grid item xs={12}>
                    <CalculatorHUD cart={cart} handleSelectItem={handleSelectItem}/>
                </Grid>
                <Grid item xs={12}>
                    <Grid container
                        justifyContent='center' 
                        alignItems='center' 
                        margin='auto'   
                        display='flex' 
                        sx={{ color:"white", fontSize: {xs: '16px', sm: '18px', md: '20px', lg: '24px'}, maxWidth:'1000px', width: '85vw' }} 
                        mt={{ xs:'250px', md: '200px' }}
                        mb='60px'
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            We charge $30 per person for the first entree selected, additional items have an added cost. Rice, cabbage salad, and tzatsiki sides are included in the price. 
                        </Grid>
                        <Grid item xs={12}>    
                            To request catering for groups fewer than 10 people, please text us to arrange a call. 
                        </Grid>
                        <Grid item xs={12}>
                            We offer discounts for larger groups! Please schedule a call to receive an accurate quote!
                        </Grid>
                        <Grid item xs={12}>
                            For grilled meats we recommend on-site grilling for the tastiest experience, however, delivery/pick up is an option.
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <ItemSelector handleSelectItem={handleSelectItem} items={itemList} cart={cart}/>
                </Grid>
            </Grid>
        </motion.div>
    )
}





